import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WINDOW } from '@kservice';

@Component({
  selector: 'kp-code',
  templateUrl: './code.component.html',
  styleUrls: ['./code.component.scss'],
})
export class CodeComponent implements OnInit {
  token: string;
  refreshToken: string;
  error: string;
  authorizingUser: boolean;

  constructor(private _activatedRoute: ActivatedRoute, @Inject(WINDOW) private _window: Window) {}

  ngOnInit() {
    this.authorizingUser = true;
    this.token = this._activatedRoute?.snapshot?.queryParams?.['token'];
    this.refreshToken = this._activatedRoute?.snapshot?.queryParams?.['refresh'];
    this.error = this._activatedRoute?.['error'];

    // only show "Authorizing message" for 8s max
    setTimeout(() => {
      this.authorizingUser = false;
    }, 8000);

    if (this.token != null && this.token !== '' && this.refreshToken != null && this.refreshToken !== '') {
      if (this._window.opener && typeof (this._window.opener as any).kpUpdateUser === 'function') {
        void this.updateUserAndClose();
      }
    }
  }

  private async updateUserAndClose() {
    const updatedUser = await (this._window.opener as any)
      .kpUpdateUser({ token: this.token, refreshToken: this.refreshToken })
      .catch((error) => {
        console.warn(error);
        setTimeout(this.close.bind(this), 8000);
      });
    if (updatedUser) {
      this.authorizingUser = false;
      this.close();
    } else {
      // If there was a problem updating the user, but it didn't throw an error, close window after 20s
      console.warn({ error: 'SSO_LOGIN_ERROR', message: 'problem updating the user but an error was not thrown' });
      setTimeout(this.close.bind(this), 16000);
    }
  }

  close() {
    this._window.close();
  }
}
